<nav class="header-container">
    <a href="/home">
        <img [hidden]="currentRoute !== '/learn_more'" src="../../assets/svg/accent_logo_color.svg" alt="accent logo">
        <img [hidden]="currentRoute === '/learn_more'" src="../../assets/svg/accent_logo_white.svg" alt="accent logo">
    </a>
</nav>